import type { WeeklyPulseRow } from "@/lib/types";

export const WEEKLY_PULSE: WeeklyPulseRow[] = [
  { week: "Apr 14", onTrack: 12, atRisk: 2, blocked: 0, highlight: "Alpha+ kicked off with 5 accounts. EB launch same week — monitoring resource strain.", decision: "" },
  { week: "Apr 21", onTrack: 0, atRisk: 0, blocked: 0, highlight: "", decision: "" },
  { week: "Apr 28", onTrack: 0, atRisk: 0, blocked: 0, highlight: "", decision: "" },
  { week: "May 5", onTrack: 0, atRisk: 0, blocked: 0, highlight: "", decision: "" },
  { week: "May 12", onTrack: 0, atRisk: 0, blocked: 0, highlight: "", decision: "" },
  { week: "May 19", onTrack: 0, atRisk: 0, blocked: 0, highlight: "", decision: "" },
];
